import React, { useEffect, useState } from 'react';
import { getUserById, updateUser } from '../services/userService';
import { useAuth } from '../context/AuthContext';
import { User } from '../types/User';
import { formatPhoneNumber } from '../services/formatter.service';
import { useToast } from '../context/ToastContext';

export const UserProfileComponent: React.FC = () => {
    const { user: authUser } = useAuth();
    const [user, setUser] = useState<User | null>(null);
    const [isEditing, setIsEditing] = useState<boolean>(false);
    const [formData, setFormData] = useState<Partial<User>>({});
    const { addToast } = useToast();

    useEffect(() => {
        const fetchUser = async () => {
            if (authUser?.userId) {
                const fetchedUser = await getUserById(authUser.userId);
                setUser(fetchedUser);
                setFormData({
                    first_name: fetchedUser?.first_name,
                    last_name: fetchedUser?.last_name,
                    email: fetchedUser?.email,
                    phone_number: fetchedUser?.phone_number
                });
            }
        };

        fetchUser();
    }, [authUser?.userId]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;

        let newValue = value;

        if (name === 'phone_number') {
            // Strip non-numeric characters except "+"
            newValue = newValue.replace(/[^\d+]/g, '');

            // Ensure it starts with "+" and only has digits after
            if (!newValue.startsWith('+1')) {
                newValue = '+1' + newValue.replace(/^\+/, '');
            }
        }
        setFormData((prev) => ({ ...prev, [name]: newValue }));

    };

    const handleUpdate = async () => {
        const formattedPhoneNumber = formatPhoneNumber(formData.phone_number || '');
        if (!formData.first_name || formData.first_name.length < 2) {
            addToast('First name must be at least 2 characters', true);
            return;
        }
        if (!formData.last_name || formData.last_name.length < 2) {
            addToast('Last name must be at least 2 characters', true);
            return;
        }
        if (!formattedPhoneNumber) {
            addToast('Invalid phone number', true);
            return;
        }
        if (user && authUser?.userId) {
            formData.phone_number = formattedPhoneNumber;
            const updated = await updateUser(authUser.userId, {
                ...user,
                ...formData,
            });
            if (updated) {
                setUser(updated);
                setIsEditing(false);
            }
        }
    };

    if (!user) return <p>Loading user profile...</p>;

    return (
        <div className="card" style={{ maxWidth: 525, backgroundColor: 'white'}}>
            <h2>Profile</h2>

            <div style={{ marginBottom: '10px' }}>
                <label><strong>Email (Cannot Be Changed):</strong></label>
                {/* {isEditing ? (
                    <input
                        name="email"
                        value={formData.email || ''}
                        onChange={handleChange}
                        style={{ width: '100%', padding: '8px' }}
                    />
                ) : ( */}
                    <p>{user.email}</p>
                {/* )} */}
            </div>

            <div style={{ marginBottom: '10px' }}>
                <label><strong>First Name:</strong></label>
                {isEditing ? (
                    <input
                        name="first_name"
                        value={formData.first_name || ''}
                        onChange={handleChange}
                        style={{ width: '100%', padding: '8px' }}
                        minLength={2}
                        maxLength={100}
                        required
                    />
                ) : (
                    <p>{user.first_name}</p>
                )}
            </div>

            <div style={{ marginBottom: '10px' }}>
                <label><strong>Last Name:</strong></label>
                {isEditing ? (
                    <input
                        name="last_name"
                        value={formData.last_name || ''}
                        onChange={handleChange}
                        style={{ width: '100%', padding: '8px' }}
                        minLength={2}
                        maxLength={100}
                        required
                    />
                ) : (
                    <p>{user.last_name}</p>
                )}
            </div>

            <div style={{ marginBottom: '10px' }}>
                <label><strong>Phone Number:</strong></label>
                {isEditing ? (
                    <input
                        name="phone_number"
                        value={formData.phone_number || ''}
                        onChange={handleChange}
                        style={{ width: '100%', padding: '8px' }}
                        minLength={10}
                        maxLength={12}
                        placeholder={'2345678901'}
                        required
                    />
                ) : (
                    <p>{user.phone_number}</p>
                )}
            </div>

            {isEditing ? (
                <div className="buttonsRow">
                    <div className="buttonsLeft">
                    <button onClick={() => setIsEditing(false)} className="cancelButton">Cancel</button>
                    </div>
                    <button onClick={handleUpdate} style={{ marginRight: '10px' }}>
                        Save
                    </button>

                </div>
            ) : (
                <div className='buttonsRow'>
                    <div className='buttonsLeft'>
                        </div>
                <button onClick={() => 
                {setIsEditing(true);
                    setFormData({
                    first_name: user?.first_name,
                    last_name: user?.last_name,
                    email: user?.email,
                    phone_number: user?.phone_number
                });
                }}>Edit Profile</button>
                </div>
            )}
        </div>
    );
};
